export default __webpack_public_path__ + "static/12-862b9ff6a311f0be4e2ad5de66ea295c.webp";